import { environment } from '../../src/environments/environment';
import { MUser } from '@argalis-apps/models';

export const ModuleMap = [
  {
    name: 'AccountModule',
    config: { routingBaseUri: 'account', themingClassName: 'account-theme' }
  },
  {
    name: 'AuthModule',
    config: { routingBaseUri: 'auth', themingClassName: 'account-theme' }
  },
  {
    name: 'CartModule',
    config: { options: { actif: true }, routingBaseUri: 'cart', themingClassName: 'cart-theme' }
  },
  {
    name: 'CatalogModule',
    config: { routingBaseUri: 'catalog', themingClassName: 'catalog-theme' }
  }
];

export const accountModuleConfig = { routingBaseUri: 'account', themingClassName: 'account-theme' };
export const authModuleConfig = { routingBaseUri: 'auth', accountCreation: true, themingClassName: 'account-theme' };
export const globalModuleConfig = { options: environment, eTypeUser: MUser.ETypeUser.FORMATEUR };
